import { biModal } from './modal.js';

class ModalList {
	init(slideShow) {
		/**
		 * Add modals to window.biModalList for global reference to the modal from other objects/functions
		 */
		window.biModalList = {};

		jQuery('.modal').each(function (index, element) {
			window.biModalList[jQuery(element).data('name')] =
				Object.create(biModal).init(element);
		});

		jQuery('.slideshow').each(function (index, element) {
			Object.create(slideShow).init(element);
		});
	}
}

const instance = new ModalList();
export default instance;
